import Phaser from "phaser";

/** Left HUD column — shared geometry for chrome, toasts, and waypoint insets. */

export const HUD_LEFT_X = 12;
/** Radio icon (and Unstuck under it) sit further right than the main left stack. */
export const HUD_RADIO_X = HUD_LEFT_X + 16;
export const HUD_TIMER_Y = 10;
export const HUD_TIMER_BLOCK_H = 34;
export const HUD_BTN_GAP = 6;
/** Extra gap before the radio button in the left stack. */
export const HUD_RADIO_TOP_GAP = 12;
export const HUD_LEFT_RESERVE_W = 200;
/** Space reserved at bottom for interact hint (GameScene), not action buttons. */
export const HUD_BOTTOM_RESERVE_PX = 72;

export type HudChromeObjects = {
  timer: Phaser.GameObjects.Text;
  caseBtn: Phaser.GameObjects.Text;
  mapBtn: Phaser.GameObjects.Text;
  radioBtn: Phaser.GameObjects.Text;
  helpBtn: Phaser.GameObjects.Text;
  stopFollowBtn: Phaser.GameObjects.Text;
  unstuckBtn: Phaser.GameObjects.Text;
};

export type HudLayoutMetrics = {
  leftReserveW: number;
  stackBottomY: number;
  radioAnchorY: number;
};

function stackButton(obj: Phaser.GameObjects.Text, x: number, y: number): number {
  obj.setPosition(x, y);
  return y + obj.displayHeight + HUD_BTN_GAP;
}

/** Vertical stack under the investigation clock (Case → Map → Help → Stop following → Radio → Unstuck). */
export function layoutHudChrome(
  _width: number,
  _height: number,
  objects: HudChromeObjects
): HudLayoutMetrics {
  objects.timer.setPosition(HUD_LEFT_X, HUD_TIMER_Y);

  let y = HUD_TIMER_Y + HUD_TIMER_BLOCK_H + HUD_BTN_GAP;
  let maxRight = HUD_LEFT_X;
  let radioPlaced = false;

  const beforeRadio = [
    objects.caseBtn,
    objects.mapBtn,
    objects.helpBtn,
    objects.stopFollowBtn,
  ];

  for (const btn of beforeRadio) {
    if (!btn.visible) continue;
    y = stackButton(btn, HUD_LEFT_X, y);
    maxRight = Math.max(maxRight, HUD_LEFT_X + btn.displayWidth);
  }

  if (objects.radioBtn.visible) {
    y += HUD_RADIO_TOP_GAP;
    y = stackButton(objects.radioBtn, HUD_RADIO_X, y);
    maxRight = Math.max(maxRight, HUD_RADIO_X + objects.radioBtn.displayWidth);
    radioPlaced = true;
  }

  if (objects.unstuckBtn.visible) {
    y = stackButton(objects.unstuckBtn, HUD_RADIO_X, y);
    maxRight = Math.max(maxRight, HUD_RADIO_X + objects.unstuckBtn.displayWidth);
  }

  const stackBottomY = y > HUD_TIMER_Y + HUD_TIMER_BLOCK_H ? y - HUD_BTN_GAP : y;
  const radioAnchorY = radioPlaced
    ? objects.radioBtn.y + objects.radioBtn.displayHeight
    : stackBottomY;

  return {
    leftReserveW: Math.max(HUD_LEFT_RESERVE_W, maxRight + 12),
    stackBottomY,
    radioAnchorY,
  };
}
